<ng-container *ngIf="visible">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>